import Api from '../../../../Api';
import { ICategory } from '../../../../shared-interfaces/Notation/ICategory';

const CategoryService = {
  /**
   * This should only be used to grab ALL categories.
   * You probably want to use NotationAttributeContext instead.
   *
   * @see NotationAttributeContext
   */
  getCategories: async function (activeOnly?: boolean): Promise<ICategory[]> {
    const response = await Api.get('category', {
      active: activeOnly,
    });
    return response.data as ICategory[];
  },
  createCategory: async function (category: ICategory): Promise<ICategory> {
    const response = await Api.post('category', category);
    return response.data as ICategory;
  },
  updateCategory: async function (category: ICategory): Promise<ICategory> {
    const response = await Api.post(`category/${category.id}`, category);
    return response.data as ICategory;
  },
};

export default CategoryService;
